export default __webpack_public_path__ + "static/media/property_251.7af62223.png";